<!--
 * @Author: 
 * @Date: 
 * @LastEditors: 诺
 * @LastEditTime: 2022-10-29 11:11:40
 * @Description: file content
 -->
<template>
  <div class="bg">
    <div class="bgImg"></div>
    <BaseImg :option="{style: {'margin-top':'14px','margin-left':'16px',width: '71px','align-self': 'flex-start'},url: 'logo.png',}"/>
    <BaseImg :option="{style: {'margin':'27px auto 0',width: '100%',},url: 'slogan.png',}"/>
    <BaseImg :option="{style: {'margin':'27px auto 0',width: '100%',},url: 'sign_bg_1.png',}"/>
    <div class="friends-box">
      <div class="friends-list">
        <div class="list-item" v-for="(item, index) in friendList" :key="index" >
          <div class="head-img">
            <img :src="item.headImg" alt="">
          </div>
          <div class="name">{{item.nickName}}通过你的召唤成功进入活动！</div>
        </div>
        <div class="no-data" v-if="friendList.length === 0">暂无好友助力~</div>
      </div>
    </div>
    <BaseImg :option="{style: {'margin':'0 auto',width: '100%',},url: 'sign_bg_3.png',}"/>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {},
  data() {
    return {
      friendList: [],
      myRank: {},
      myIndex: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    async getRankingList() {
      const data = await this.$httpdf.get(this.apiHost + 'assistance/myFriends')
      if (data.code == 0) {
        this.friendList = data.data.filter((v)=> v!=null)
        // this.friendList = [...this.friendList, ...this.friendList,...this.friendList,...this.friendList,...this.friendList]
      }
    }
  },
  mounted() {
    this.getRankingList();
  },
};
</script>
<style lang="scss" scoped>
div{
  position: relative;
}
.bg {
  padding-bottom:80px;
  background: linear-gradient(0deg, #FCC229 0%, #FDD142 49%, #FDD94F 100%);
  .bgImg{
    position: absolute;
    z-index:0;
    width: 343px;
    background-image: url( $imgHost + 'bg.png?v=' + $OSSVersion);
    background-position: top center;
    background-size: 100% auto;
    border: 1px solid #231815;
    border-radius: 0px 0px 62px 0px;
    top:51px;
    bottom:40px;
  }
  
  .friends-box {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 300px;
    background: url( $imgHost + 'sign_bg_2.png?v=' + $OSSVersion) 0 0 / 100% repeat;
    p {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
    }
    .friends-list {
      width:271px;
      height: 300px;
      box-sizing: border-box;
      overflow: auto;
      position: relative;
      margin: 0 auto;
      z-index: 2;
      .list-item {
        position: relative;
        display: flex;
        align-items: center;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #201715;
        padding: 10px 0;
        &+.list-item {
          border-top: 1px solid rgba(33, 24, 22, 0.1)
        }
        .rank {
          width: 30px;
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #fff;
          text-align: center;
        }
        .head-img {
          background: #fff;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          // margin: 0 auto;
          position: relative;
          img {
            border-radius: 50%;
          }
        }
        .name {
          flex: 1;
          margin-left: 12px;
          span {
            font-size: 10px;
            opacity: 0.74;
          }
        }
        .txt {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FEE481;
          span {
            font-size: 18px;
            color: #FF4C1D;
          }
        }
        .score {
          margin-right: 25px; 
        }
        &.my-rank {
          .name {
            font-weight: 500;
          }
          .score {
            background: linear-gradient(0deg, #00C2FD 0.4150390625%, #00CDC6 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }
  }
  .no-data {
    width: 100%;
    height: 100%;
    font-size: 15px;
    color: #2D2D2D;
    @extend .flex-center-center;
    text-align: center;
    line-height: 180%;
  }
}
</style>